module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloud-bottom-5a005f1fbcd0409ddf2349797d9a1585.svg";